module.exports = __webpack_public_path__ + "static/media/FrancoisOne-Regular.4a2c9e24.ttf";